import { combineReducers } from "redux";

import aarsrapportSubmittedFormReducer from "./aarsrapportSubmittedFormReducer";
import antallIleggelserPerIleggelsetypeSubmittedFormReducer from "./antallIleggelserPerIleggelsetypeSubmittedFormReducer";
import makuleringerSubmittedFormReducer from "./makuleringerSubmittedFormReducer";
import piggdekkontrollerSubmittedFormReducer from "./piggdekkontrollerSubmittedFormReducer";
import skiftloggSubmittedFormReducer from "./skiftloggSubmittedFormReducer";
import uferdigstilteKlagesakerSubmittedFormReducer from "./uferdigstilteKlagesakerSubmittedFormReducer";
import ventilstillingerSubmittedFormReducer from "./ventilstillingerSubmittedFormReducer";

export default combineReducers({
  aarsrapportSubmittedForm: aarsrapportSubmittedFormReducer,
  antallIleggelserPerIleggelsetypeSubmittedForm:
    antallIleggelserPerIleggelsetypeSubmittedFormReducer,
  ventilstillingerSubmittedForm: ventilstillingerSubmittedFormReducer,
  piggdekkontrollerSubmittedForm: piggdekkontrollerSubmittedFormReducer,
  uferdigstilteKlagesakerSubmittedForm:
    uferdigstilteKlagesakerSubmittedFormReducer,
  skiftloggSubmittedForm: skiftloggSubmittedFormReducer,
  makuleringerSubmittedForm: makuleringerSubmittedFormReducer,
});
